export default __webpack_public_path__ + "static/catchup-image-d8dbf2ebf276df5105258ccb019ed1ad.svg";